<template>
  <div>
    <CRow>
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="refundType">Refund Types</h1>
        <CCard>
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'refundType.new'}">
                <CButton block color="primary" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <AjaxTable
              :fields="fields"
              :data="refundTypes"
              :fetch="fetchRefundTypeList"
            >
              <template #actions="{item}">
                <td class="text-right">
                  <CButton
                    size="sm"
                    variant="outline"
                    color="primary"
                    class="mr-2"
                    @click="$router.push({name: 'refundType.edit', params: {id: item.id}})"
                    v-translate translate-context="list.actions"
                  >
                    Edit
                  </CButton>
                  <CButton
                    @click="onDelete(item.id)"
                    size="sm"
                    variant="outline"
                    color="danger"
                    v-translate translate-context="list.actions"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
            </AjaxTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AjaxTable from "@/domain/core/components/AjaxTable.vue";

export default {
  name: 'ListRefundType',
  components: {AjaxTable},
  data() {
    return {
      fields: [
        {key: 'id', label: this.$pgettext('refundType.list', 'ID')},
        {key: 'code', label: this.$pgettext('refundType.list', 'Code')},
        {key: 'name', label: this.$pgettext('refundType.list', 'Name')},
        {key: 'is_active', label: this.$pgettext('refundType.list', 'Active'), boolean: true},
        {key: 'actions', label: this.$pgettext('refundType.list', 'Actions'), sorter: false, filter: false}
      ],
    }
  },
  computed: {
    ...mapGetters('refundType', ['refundTypes']),
  },
  methods: {
    ...mapActions('refundType', ['fetchRefundTypeList', 'deleteRefundType']),

    onDelete(id) {
      this.confirm({
        title: 'Are you sure?',
        message: 'This action is irreversible',
        cb_confirm: async () => {
          await this.deleteRefundType(id)
        }
      })
    }
  }
}
</script>
